import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=0c2f058e&scoped=true&"
import script from "./image-lightbox.vue?vue&type=script&lang=js&"
export * from "./image-lightbox.vue?vue&type=script&lang=js&"
import style0 from "./image-lightbox.vue?vue&type=style&index=0&id=0c2f058e&lang=scss&scoped=true&"
import style1 from "./image-lightbox.vue?vue&type=style&index=1&id=0c2f058e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f058e",
  null
  
)

export default component.exports